import { isBombType } from '../../../types/bombTypes';
import { booleanParser, numberParser } from '../inboundParsers';
import { optionalSeatIndexParser } from './utils/pokerInboundUtils';
export const ADD_BOMB_PAYLOAD_DEFINITION = {
    definitionParts: [
        { name: 'bombType', parser: bombTypeParser },
        { name: 'deprecatedIsDynamic', parser: booleanParser },
        { name: 'fromSeatIndex', parser: optionalSeatIndexParser },
        { name: 'deprecatedFromX', parser: numberParser },
        { name: 'deprecatedFromY', parser: numberParser },
        { name: 'deprecatedToX', parser: numberParser },
        { name: 'deprecatedToY', parser: numberParser },
        { name: 'deprecatedVelocity', parser: numberParser },
        { name: 'deprecatedRadians', parser: numberParser },
        { name: 'deprecatedDurationMs', parser: durationMsParser },
        { name: 'toSeatIndex', parser: optionalSeatIndexParser },
        { name: 'deprecatedGravity', parser: numberParser },
        { name: 'deprecatedOffsetX', parser: numberParser },
        { name: 'deprecatedOffsetY', parser: numberParser },
        { name: 'deprecatedBasicAngle', parser: numberParser },
        { name: 'deprecatedFlipX', parser: numberParser },
        { name: 'deprecatedBasicFlipY', parser: numberParser },
        { name: 'deprecatedDealerAbsolute', parser: numberParser },
        { name: 'deprecatedArcHighOnly', parser: numberParser },
        { name: 'deprecatedBounceOnHit', parser: booleanParser },
        { name: 'deprecatedRotateToZero', parser: booleanParser },
        { name: 'delay', parser: numberParser },
        { name: 'randomSeed', parser: numberParser }
    ]
};
function durationMsParser(str) {
    const timeFactor = 16; // not sure where this value comes from, but it was done in Flash version
    return (numberParser(str) / timeFactor) * 1000;
}
function bombTypeParser(str) {
    if (isBombType(str)) {
        return str;
    }
    console.warn(`Unrecognized bomb type '${str}'`);
}
